import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {type UpscaleImageParams, fetchUpscaledImages} from './requests'

export const upscaleImages = async (
    environmentContext: EnvironmentContext,
    createExtArgs: CreateExtArgs,
    componentPointers: CompRef[]
): Promise<void> => {
    return generateAndInjectImages<UpscaleImageParams>(
        environmentContext,
        createExtArgs,
        componentPointers,
        (_key, url) => ({
            imageUrl: url
        }),
        fetchUpscaledImages
    )
}
